export default "__VITE_ASSET__BIMjRseJ__"